var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 5,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.821 1.02L4.932 4.826a.62.62 0 01-.864 0L.179 1.02a.589.589 0 010-.846.62.62 0 01.864 0L4.5 3.557 7.957.175a.62.62 0 01.864 0 .589.589 0 010 .846z",
    fill: "#8E8E8E"
  })));
}

export default SvgArrowDown;